const messages: { [key in string]: string } = {
  USER_NOT_FOUND: 'User not found',
  TUTOR_WRONG_CREDENTIALS: 'You have entered an invalid email or password.',
  DEFAULT: 'Something went wrong, try again later.'
}

export const printApiMessage = (code = messages.DEFAULT) => (code in messages ? messages[code] : code)
